import * as version from '../package.json';

export type PackageType = {
  name: string;
  version: string;
};

export const packageJson = version as PackageType;
